import React, { useRef, useEffect, useState } from "react";

const Accordion = ({ isOpen, children }) => {
  const ref = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setHeight(ref.current.scrollHeight + 10);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <div
      style={{
        overflow: "hidden",
        transition: "height 0.4s ease",
        height: height
      }}
    >
      <div ref={ref}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
